import Header from './components/Header';
import HeroSection from './components/HeroSection';
import CarouselSection from './components/CarouselSection';
import TopicsSection from './components/TopicsSection';
import AppSection from './components/AppSection';
import MediaSection from './components/MediaSection';
import ContactSection from './components/ContactSection';
import CommentsSection from './components/CommentsSection';
import RankingSection from './components/RankingSection';
import AboutSection from './components/AboutSection';
import FeaturesSection from './components/FeaturesSection';
import CardsSection from './components/CardsSection';
import FaqSection from './components/FaqSection';
import UpdatesSection from './components/UpdatesSection';
import IndexSection from './components/IndexSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <HeroSection />
        <CarouselSection />
        <TopicsSection />
        <AppSection />
        <MediaSection />
        <ContactSection />
        <CommentsSection />
        <RankingSection />
        <AboutSection />
        <FeaturesSection />
        <CardsSection />
        <FaqSection />
        <UpdatesSection />
        <IndexSection />
      </main>
      <Footer />
    </div>
  );
}